<h1 mat-dialog-title>Bienvenue dans votre boutique!</h1>
<div mat-dialog-content>
  <h3>Vous pouvez dès maintenant partager vos outils <b>gratuits</b></h3>
  <h3>Terminez votre adhésion afin de <b>vendre</b> sur Créasources</h3>
  <p>
    Nous utilisons Stripe, une plateforme de paiement hautement sécuritaire,
    pour vous transférer vos ventes tous les mois
  </p>
  <a href="https://stripe.com/fr-ca" rel="noopener" target="_blank">
    <img
      alt="Powered by Stripe"
      src="assets/images/Powered-by-Stripe-blurple.webp"
    />
  </a>
  <p>
    Des questions? Consultez notre
    <a [routerLink]="['/faq']" target="_blank">FAQ</a>
  </p>
</div>
<div mat-dialog-actions>
  <button
    [mat-dialog-close]="false"
    data-test="dismissOnboarding"
    gaEvent="dismiss_onboarding"
    mat-button
  >
    Plus tard
  </button>
  <button
    gaEvent="open_onboarding"
    data-test="finishOnboarding"
    mat-raised-button
    color="primary"
    [mat-dialog-close]="true"
  >
    Terminer mon adhésion
  </button>
</div>
